<!-- <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)">
  <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)">
</div>
  <div  class="files-list" *ngFor="let file of files;let i=index">
    <p>{{ file }}</p>
    <button class="delete-file" (click)="deleteAttachment(i)">
      <img src="../../../../../assets/images/Recycle_Bin_Full.png">
    </button>
  </div>
<img [src]="imgURL" *ngIf="imgURL" style="height: 30%; width: 30%;"> -->



<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-16" [routerLink]="'/settings'">
              <mat-icon>arrow_back</mat-icon>
          </button>
            <h2 class="m-0">{{'CONFIGURACION.REQTEC.TITUHEAD' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span>{{'CONFIGURACION.REQTEC.INFO' | translate}}</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" fusePerfectScrollbar >

              <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)">
                <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)">
              </div>
                <div  class="files-list" *ngFor="let file of files;let i=index">
                  <p>{{ file }}</p>
                  <button class="delete-file" (click)="deleteAttachment(i)">
                    <img src="../../../../../assets/images/Recycle_Bin_Full.png">
                  </button>
                </div>
              <img [src]="imgURL" *ngIf="imgURL" style="height: 30%; width: 30%;">

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
